import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 13, height: 8, viewBox: "0 0 13 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1.25L6.5 6.75L12 1.25", stroke: "white", strokeWidth: 1.5 }));
export default SvgArrowDown;
